import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'table-hr-invitations',
	templateUrl: './table-hr-invitations.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class TableHrInvitationsComponent implements OnInit {
	
	@Input() generatedPreview: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {

	}
	
}